import React from "react";
import mapServiceItem from "./mapServiceItem";

export default function ProductionPillars({ items }) {
    return (
        <div className="production-pillars">
            {items.map((item) => {
                const card = mapServiceItem(item);
                return (
                    <article className="production-pillar" key={card.title}>
                        <span>{card.marker}</span>
                        <h3>{card.title}</h3>
                        <p>{card.text}</p>
                    </article>
                );
            })}
        </div>
    );
}
